import React from "react";
import moment from "moment";
import CheckGreenCircleIcon from "../../../../assets/svg/icons/common/check-green-circle";
import MinusCircle from "../../../../assets/svg/icons/common/MinusCircle";
import styles from "./ChargebackChildRow.module.scss";

const formatCurrency = (amount) => {
  if (!amount) return "$0.00";
  const value = Math.abs(parseFloat(amount));
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(value);
};

const formatDate = (date) => {
  return moment(date).format('MM/DD/YYYY');
};

const formatReferenceNumber = (number) => {
  if (!number) return "";
  // Remove any non-digit characters
  const digits = number.replace(/\D/g, '');
  // Split into groups of 4
  return digits.replace(/(\d{4})/g, '$1 ').trim();
};

const ChargebackChildRow = ({ details }) => {
  const representedAmount = details?.reduce((acc, curr) => {
    // Use amount instead of trans_amount for consistency
    const value = parseFloat(curr.amount) || 0;
    return curr.type.toLowerCase() === 'ach' ? acc - value : acc + value;
  }, 0);

  return (
    <div className={styles.container}>
      <table className={styles.table}>
        <thead>
          <tr className={styles.header_row}>
            <td></td>
            <td>REFERENCE NO.</td>
            <td>TYPE</td>
            <td>TRANS. AMOUNT</td>
            <td>DATE</td>
            <td>DESCRIPTION</td>
            <td>REPRESENTED DATE</td>
          </tr>
        </thead>
        <tbody>
          {details?.map((detail, index) => (
            <tr 
              key={index} 
              className={`${styles.row} ${styles.child_app} ${
                index !== details.length - 1 ? styles.line : ''
              }`}
            >
              <td className={styles.reference_cell} title={detail.reference_number}>
                {formatReferenceNumber(detail.reference_number)}
              </td>
              <td>
                <span>
                  <div
                    className={`${styles.transactionType} ${
                      styles[detail.type.toLowerCase()]
                    }`}
                  >
                    {detail.type.toLowerCase() === 'transaction' ? <CheckGreenCircleIcon /> : <MinusCircle />}
                    {detail.type}
                  </div>
                </span>
              </td>
              <td className={`${styles.amountCell} ${detail.type.toLowerCase() === 'ach' ? styles.negative : ''}`} title={formatCurrency(detail.amount)}>
                {formatCurrency(detail.amount)}
              </td>
              <td>{detail.date ? formatDate(detail.date) : ''}</td>
              <td title={detail.transaction_description}>
                {detail.transaction_description}
              </td>
              <td>{detail.represented_date ? formatDate(detail.represented_date) : ''}</td>
            </tr>
          ))}
          <tr className={styles.represented}>
            <td><span></span></td>
            <td><span className={styles.label}>REPRESENTED:</span></td>
            <td><span></span></td>
            <td>
              <span className={styles.amount} title={formatCurrency(representedAmount)}>
                {formatCurrency(representedAmount)}
              </span>
            </td>
            <td><span></span></td>
            <td><span></span></td>
            <td><span></span></td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default ChargebackChildRow; 